import { render, staticRenderFns } from "./RouterBandList.vue?vue&type=template&id=bc6819de&"
import script from "./RouterBandList.vue?vue&type=script&lang=js&"
export * from "./RouterBandList.vue?vue&type=script&lang=js&"
import style0 from "./RouterBandList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports